export default __webpack_public_path__ + "static/media/labor_927_3.71f29b76.jpg";